import React, { memo } from "react";
import { Chart } from "react-google-charts";

import * as DashboardConstants from '.././DashboardConstants';

const TreemapFile = (props)=> {
    return (

        <div className="treeMap">
            <Chart
                width={'inherit'}
                height={'600px'}
                chartType="TreeMap"
                loader={<div>{DashboardConstants.LoadingChart}</div>}
                is3D={true}
                data={props.cbmData}
                chartEvents={props.chartEvents}
                loading={props.cbmDataLoading}
                fontFamily="IBM Plex Sans"
                options={{
                    headerHeight: 25,
                    fontColor: 'black',
                    fontSize: 14,
                    showScale: false,
                    scaleTitle: 'success',
                    chartArea: { 'width': '100%', 'height': '80%' },
                    maxDepth: 2,
                    maxPostDepth: 2,
                    fontFamily: "IBM Plex Sans",
                    minColor: '#DA1E28',
                    midColor: '#F7F7F7',
                    maxColor: '#24A148',
                    textStyle: {
                        fontName: 'IBM Plex Sans'
                    },
                    titleTextStyle: {
                        color: "white",
                        backgroundColor: "black"
                    },
                    // eventsConfig: {
                    //     highlight: ['click'],
                    //     unhighlight: ['mouseout'],
                    //     // rollup: ['contextmenu'],
                    //     // drilldown: ['dblclick'],
                    // },
                    vAxis: {
                        direction: 1,
                        slantedText: true,
                        minValue: 0,
                        maxValue: 270,
                        title: "High ROI"
                    },
                    generateTooltip: (row, size, value) => {
                        return (
                            '<div style="background:#fd9; padding:10px; border-style:solid"> ' +
                            // 'Datatable row: ' + row + '<br>' +
                            // 'Dependencies : ' + size + '<br>' +
                            // props.kpi + ':' + 
                            props.kpiValue + '<br>' +
                            '</div>'
                        )
                    },
                }}
            />
        </div>

    )
}
export default memo(TreemapFile);